import { render, staticRenderFns } from "./ImageProductSetup.vue?vue&type=template&id=787aad8e&scoped=true&"
import script from "./ImageProductSetup.vue?vue&type=script&lang=js&"
export * from "./ImageProductSetup.vue?vue&type=script&lang=js&"
import style0 from "./ImageProductSetup.vue?vue&type=style&index=0&id=787aad8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787aad8e",
  null
  
)

export default component.exports